import { EkranBledu } from '@insolitum/ui';
import { LogOut } from 'lucide-react';

import { useAuth } from '../providers/AuthProvider';

/**
 * Shown by ProtectedRoute to authenticated non-super-admins while the platform
 * maintenance flag (system_settings.global.maintenanceMode) is on. Super-admins
 * bypass this so they can still reach /super-admin and lift maintenance.
 *
 * Wygląd jest wspólnym ekranem awarii (`EkranBledu`, organy „w serwisie"),
 * ale zdanie zostaje własne, a nie domyślne „nic nie musisz robić": flaga
 * jest czytana RAZ na załadowanie aplikacji (`useMaintenanceMode` trzyma ją
 * w pamięci modułu), więc koniec prac zobaczy dopiero ten, kto odświeży.
 * Domyślne zdanie obiecywałoby powrót, którego ten ekran sam nie wykona.
 */
export function MaintenancePage() {
  const { signOut } = useAuth();

  return (
    <EkranBledu
      wariant="serwis"
      uklad="pelny"
      tytul="Przerwa techniczna"
      tresc={
        <p>
          Platforma Insolitum Universe jest chwilowo niedostępna z powodu prac konserwacyjnych.
          Prosimy spróbować ponownie za kilka chwil.
        </p>
      }
      akcje={
        <>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="btn btn--primary btn--lg"
          >
            Odśwież
          </button>
          <button
            type="button"
            onClick={() => {
              void signOut();
            }}
            className="btn btn--secondary btn--lg"
          >
            <LogOut className="w-5 h-5" />
            Wyloguj
          </button>
        </>
      }
    />
  );
}
